// extracted by mini-css-extract-plugin
module.exports = {"lNews__title":"g_s","cGatsbyBackground":"g_b","lNews__inner":"g_t","lNews":"g_v","animationMarquee":"g_d"};